//Excludes all results with thickness = '-'
const getResultsQuery = (type, placement, diameter, bearing, insulationClass, temp) => `\
SELECT name, thickness, colored
FROM insulation
WHERE type = '${type}' 
AND placement = '${placement}' 
AND diameter = '${diameter}'
AND bearing = '${bearing}'
AND insulation_class = '${insulationClass}'
AND temp = '${temp}'
AND NOT thickness = '-'`

const getWidthsQuery = () => `\ 
SELECT DISTINCT width from dimensions
WHERE width IS NOT NULL`

const getHeightsQuery = () => `\
SELECT DISTINCT height from dimensions`;

const getDiametersQuery = (type) => `\
SELECT DISTINCT diameter
FROM insulation
WHERE type = '${type}'`;

const getBearingsQuery = (type) => `\
SELECT DISTINCT bearing
FROM insulation
WHERE type = '${type}'`;

const getInsulationClassesQuery = (type, placement, diameter, bearing) => `\
SELECT DISTINCT insulation_class
FROM insulation
WHERE type = '${type}' 
AND placement = '${placement}'
AND diameter = '${diameter}'
AND bearing = '${bearing}'
ORDER BY insulation_class`;

const getTemperaturesQuery = (type, placement, diameter, bearing, insulationClass) => `\
SELECT DISTINCT temp
FROM insulation
WHERE type = '${type}' 
AND placement = '${placement}'
AND diameter = '${diameter}'
AND bearing = '${bearing}'
AND insulation_class = '${insulationClass}'
ORDER BY temp`;

export {
    getResultsQuery,
    getWidthsQuery,
    getHeightsQuery,
    getDiametersQuery,
    getBearingsQuery,
    getInsulationClassesQuery,
    getTemperaturesQuery
};